import { render, staticRenderFns } from "./ReviewHome.vue?vue&type=template&id=e1182632&scoped=true"
import script from "./ReviewHome.vue?vue&type=script&lang=js"
export * from "./ReviewHome.vue?vue&type=script&lang=js"
import style0 from "./ReviewHome.vue?vue&type=style&index=0&id=e1182632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1182632",
  null
  
)

export default component.exports